<template>
  <div class="approval-process">
    <div class="order" style="border-bottom: none">
      <div class="order-detail">
        <div>{{approvalTitle}}</div>
      </div>
    </div>
    <div class="approval-box">
      <div v-for="(approvalItem,approvalIndex) in approvalData" :key="approvalIndex" class="approval-content line"
           :class="moveRight(approvalIndex)">
        <div v-for="(item,itemIndex) in approvalItem" :key="itemIndex" >
          <div class="line" >
            <div class="approval-left margin-r10">
              <img :src="item.icon" alt="">
            </div>
            <div class="approval-right" :style="{'min-height':approvalIndex+1 < approvalData.length?'150px':'auto'}">
              <div class="right-top line">
              <span class="dot" :class="approvalIndex%2 !== 0 ? 'left' : 'right'"
                    v-if=" itemIndex < 4 && !(approvalIndex + 1 == approvalData.length && itemIndex +1 == approvalItem.length)"></span>
                <div class="step margin-r10 flex-all-center" :class="chooseColor(item.auditStatus)">{{item.step}}
                </div>
                <!--最末级没有线;除第一行，别的第一列自动短线   -->
                <div :class="checkClass(approvalIndex,itemIndex)"
                     v-if=" handleLine(approvalIndex,itemIndex)"></div>
              </div>
              <!-- 已审批返回对象-->
              <div class="right-center">
                <div class="line" v-if="Number(item.auditStatus) === 1 || Number(item.auditStatus) === 2" :class="chooseColor(item.auditStatus)">
                  <e-tooltip :content="item.nodeMember.auditMemberName   + ' '+  item.nodeMember.auditMemberPhone"
                             :setLength="16"/>
                  <el-tooltip class="item margin-t4" effect="dark" :content="item.tip" placement="top" v-if="item.tip" >
                    <i class="el-icon-question"/>
                  </el-tooltip>
                </div>
                <!--未审批返回数组-->
                <div class="line" v-for="(peoItem,index) in item.nodeMemberList" :key="index" v-else>
                  <e-tooltip :content="peoItem.auditMemberPhone ? (peoItem.auditMemberName   + ' '+  peoItem.auditMemberPhone) : peoItem.auditMemberName"
                             :setLength="20"/>
                  <el-tooltip class="item margin-t4" effect="dark" :content="item.tip" placement="top" v-if="item.tip" >
                    <i class="el-icon-question"/>
                  </el-tooltip>
                </div>
              </div>
              <div class="right-bottom" v-if="item.nodeMember">{{item.nodeMember.approveTime}}</div>
              <div class="right-tip margin-t10" v-if="showAuditRemark(item)">
                <div class="opinion">{{item.nodeMember.auditRemark}}</div>
                <div class="triangle">&#9650</div>
              </div>
            </div>
          </div>
          <!--  画折线-->
          <div :class="drawPolyline(approvalIndex,itemIndex,approvalItem)"></div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import eTooltip from './e-tooltip.vue'
  export default {
    name: "approvalProcess",
    components:{eTooltip},
    props: {
      approvalData: Array,
      approvalTitle:{
        type:String,
        default:'审批记录'
      },
    },
    methods:{
      //展示审批意见
      showAuditRemark(item){
        //询比价审批 最后意见只拒绝展示  tip是询比价专属
        if(item.tip){
          if(Number(item.auditStatus) === 2){
            return true;
          }
        }else{
          if((Number(item.auditStatus) === 1 || Number(item.auditStatus) === 2 ) && item.nodeMember.auditRemark){
            return true;
          }
        }
        return false;
      },

      //整体往右移
      moveRight(approvalIndex){
        if(approvalIndex > 0 && (approvalIndex +1  < this.approvalData.length || approvalIndex % 2 ===0)){
          return ['margin-l50']
        }
        if(approvalIndex%2 === 1){
          return ['to-right']
        }
      },
      //判断最末级有没有线   当前行比总行小就 有线
      handleLine(approvalIndex,itemIndex){
        //最后一行最后一个没有线
        if(( approvalIndex + 1 === this.approvalData.length ) && itemIndex + 1 === this.approvalData[approvalIndex].length){
          return  false
        }
        if(!(approvalIndex + 1 < this.approvalData.length && itemIndex +1 == this.approvalData[approvalIndex].length)){
          return  true
        }
      },
      //颜色设置  审批状态 0 待审批 1 审批通过 2 审批拒绝
      chooseColor(auditStatus){
        if(Number(auditStatus) === 1){
          return ['color-green']
        }else if(Number(auditStatus) === 2){
          return ['color-red']
        }else if(Number(auditStatus) === 3){//审批中
          return ['color-orange']
        }
      },
      //approvalIndex 外层循环的index
      checkClass(approvalIndex,itemIndex){
        if(approvalIndex > 0 && itemIndex < 4 && itemIndex === 0 && approvalIndex + 1 < this.approvalData.length){
          return ['interval-line','first-width']
        }else  if(approvalIndex > 0 && itemIndex < 4){
          return ['interval-line']
        }else  if(itemIndex < 4){//里面的折线
          return ['interval-line']
        }

      },
      //approvalIndex 外层循环的index
      //itemIndex内层循环的index
      //approvalItem 这一行循环的总数居
      drawPolyline(approvalIndex,itemIndex,approvalItem){
         if(approvalItem.length === 5 && approvalIndex % 2 === 0 && this.approvalData.length > approvalIndex+1){//判断右侧是否有折线
          return ['drawPolyline','drawPolyline-right'];
        } else if(approvalItem.length === 5 && approvalIndex % 2 === 1 && this.approvalData.length > approvalIndex+1){//判断左侧是否有折线
          return ['drawPolyline','drawPolyline-left'];
        }
      },
    }

  }
</script>
<style scoped lang="scss">
  .approval-process {
    .approval-box{
      padding: 20px;
      border: 1px solid #d9d9d9;
      border-top: none;
      .approval-content {
        width: 1010px;
        .approval-left {
          img {
            width: 24px;
            height: 24px;
          }
        }
        .approval-right {
          /*min-height: 150px;*/
          .right-top {
            position: relative;
            .step{
              /*width: 56px;*/
              width: 66px;
            }
            .color-green{
              color: #50AA43;
            }
            .color-red{
              color: #F0250F;
            }
            .color-orange{
              color: #EA9200;
            }
            .interval-line {
              border-top: 1px solid #d9d9d9;
              width: 92px;
              margin-top: 10px;
              margin-right: 10px;
            }
            /*除第一行 的 第一条线的长度*/
            .first-width{
              width: 50px;
            }
            /*右侧折现的长度*/
            .right-width{
              width: 50px;
            }
            .dot {
              position: absolute;
              top: 8px;
              width: 6px;
              height: 6px;
              border-radius: 50%;
              background-color: #d9d9d9;
            }
            .left{
              left: 64px;
            }
            .right{
              right: 4px;
            }
          }
          .right-center{
            max-height: 42px;
            overflow-y: auto;
          }
          .right-tip {
            position: relative;
            margin-bottom: 12px;
            .opinion{
              padding: 4px;
              padding-left: 8px;
              padding-top: 0;
              border: 1px solid #d9d9d9;
              max-width: 160px;
              max-height: 44px;
              overflow-y: auto;
            }

            .triangle{
              position: absolute;
              top: -15px;
              left: 16px;
              color: #d9d9d9;
            }
          }
        }
      }
    }

    .order {
      margin-top: 20px;
      /*height: 480px;*/
      border: 1px solid #d9d9d9;
      width: 100%;

      .order-detail {
        /* height: 44px;
        line-height: 44px;
        border-bottom: 1px solid #d9d9d9;
        border-right: 1px solid #d9d9d9;
        display: flex;
        justify-content: space-between;
        padding: 0 20px;
        font-size: 14px;
        font-weight: 400;
        color: #999999;
        background-color: #F5F5F5; */
        color: #333;
        height: 44px;
        line-height: 44px;
        background: #f5f5f5;
        padding-left: 20px;
        border-bottom: 1px solid #d9d9d9;
        font-size: 16px;
        font-weight: bold;
        span {
          color: black;
        }
      }


    }
    .line {
      display: flex;
      position: relative;
    }
    .to-right{
      justify-content: right;
    }
    .margin-l50{
      margin-left: 54px;
    }
    .drawPolyline{
      position: absolute;
      top:10px;
      right:0;
      width: 50px;
      height: 150px;
      border: 1px solid #d9d9d9;
     }
    /*画右侧折线*/
    .drawPolyline-right{
      right:0;
      border-left: none;
      &::after{
        content: '';
        display: block;
        width: 6px;
        height: 6px;
        background-color: #d9d9d9;
        border-radius: 50%;
        margin-top: 146px;
      }
     }
    /*画左侧折线*/
    .drawPolyline-left{
      left:-56px;
      border-right: none;
      &::before{
        content: '';
        display: block;
        width: 6px;
        height: 6px;
        background-color: #d9d9d9;
        border-radius: 50%;
        margin-top: 146px;
        margin-left: 46px;
      }
    }

    .margin-t10{
      margin-top: 10px;
    }
    .margin-r10{
      margin-right: 10px;
    }
    .flex-all-center{
      display: flex;
      justify-content: center;
      align-items: center;
    }

    ::-webkit-scrollbar {
      width: 4px;
    }
    ::-webkit-scrollbar-track {
      background-color: #d9d9d9;
    }
    ::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: #999;
    }
  }
</style>
